/** CoStar.Api.AptsUser.Implementation.Operations.UserIdentityMerge.MarketingBrand */
export var MarketingBrand;
(function (MarketingBrand) {
    MarketingBrand[MarketingBrand["CoStar"] = 0] = "CoStar";
    MarketingBrand[MarketingBrand["Apartments"] = 1] = "Apartments";
    MarketingBrand[MarketingBrand["ApartmentFinder"] = 2] = "ApartmentFinder";
})(MarketingBrand || (MarketingBrand = {}));
